import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REMOVE_USER_FROM_BOOKING_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getBookingUsersSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/remove_u_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRemoveUserFromBooking(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('user', args.data.user_id);
        formData.append('child_id', args.data.child_id);
        formData.append('booking_id', args.data.booking_id);
        formData.append('booking_users_id', args.data.booking_users_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            growl({ type: 'success', message: response.message });
            // Обновляем список пользователей
            yield put(getBookingUsersSagaAction({
                booking_id: args.data.booking_id
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherRemoveUserFromBooking() {
    yield takeLatest(REMOVE_USER_FROM_BOOKING_SAGA, workerRemoveUserFromBooking);
}